// 航线相关请求
import req from './index'

//获取管线
export const GetRoutesList = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesList_Get', params)
}

//新增 | 编辑 管线
export const SetRoutes = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesInfo_Set', params)
}

//删除管线
export const DelRoutes = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesInfo_Del', params)
}

//上传坐标
export const ImportPoint = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.RoutesPoint_Import', params)
}

//上传航线
export const ImportRoute = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.RoutesRoute_Import', params)
}

//获取管线详细信息 包括起飞点
export const GetRoutesInfo = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesInfo_Get', params)
}

// 批量添加单元段
export const batchAddUnitSegments = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPoint_Set', params)
}

//获取航点
export const GetRoutesPoint = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPoint_Get', params)
}

//获取航点以及航点动作
export const GetRoutesPointAction = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPointAction_Get', params)
}

//编辑航点
export const SetRoutesPoint = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPoint_Edit', params)
}

//根据经纬度获取海拔
export const GetAltitude = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.GetElev9', params)
}

//编辑航点动作
export const SetRoutesPointAction = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesPointActoin_Edit', params)
}

//编辑起飞点
export const SetTakeOff = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.RoutesTakeOff_Edit', params)
}
//临时执行
export const AirTemporary = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.Temporary', params)
}
//定点巡航-起飞高度设置
export const TakeoffAltitude = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.Takeoff_altitude_Edit', params)
}

//临时执行
export const M3Temporary = (params) => {
  return req.post('api/admin.php?s=Admin.M3Drone.startWayLine', params)
}

// 获取无人机点位
export const getUavpositionInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Airport.uavposition', params)
}

// 获取地图中展示编辑与否的权限
export const getLimitsAuthorityInfo = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.GetMapLimitation', params)
}

//上传标识桩
export const IdentifyStakeFun = (params) => {
  return req.file('api/admin.php?s=Admin.Airport.RoutesMark_Import', params)
}

// 导出管线、航点、标识桩
export const ExportWaypointsFun = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.Routes_PointExport', params)
}

// 获取航线总览数据
export const getRouteOverview = (params) => {
  return req.post('api/admin.php?s=Admin.Airport.GetAll_RoutesList', params)
}


// 获取航线类型
export const getLineType = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.RoutesCategoryList_Get', params)
}

// 编辑航线类型
export const setLineType = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.RoutesCategoryList_Set', params)
}

// 编辑航线类型
export const delLineType = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.RoutesCategoryList_Del', params)
}

// 获取当前机场下 其他的航点信息
export const getOtherRoutesInfoRoutes = (params) => {
  return req.get('api/admin.php?s=Admin.Airport.Routes_pointList', params)
}